import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6959ea267683ed001402a35f/secondhand_mobile_hub/src/app/product-details/components/ProductDetailsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6959ea267683ed001402a35f/secondhand_mobile_hub/src/components/common/Header.tsx");
